function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { connect } from 'react-redux';
import { compose, lifecycle, withHandlers, withProps } from 'recompose';
import { applicationTabSelected } from "../../../store/selectors/application";
import { applicationEnhancer } from "../enhancer";
import Application from "./Application";
var enhancer = compose(connect(function (state) {
  return {
    selectedTab: applicationTabSelected(state)
  };
}), applicationEnhancer, withProps(function (_ref) {
  var school_id = _ref.school_id,
    schools = _ref.schools;
  return {
    school: schools ? schools.find(function (e) {
      return e.id === school_id;
    }) : null
  };
}), withHandlers({
  searchParameters: function searchParameters() {
    return function () {
      var searchParam = window.location.search;
      if (!searchParam || searchParam.length <= 0) return {};
      return searchParam.substr(1).split('&').map(function (string) {
        return string.replace(/%20/g, ' ');
      }).reduce(function (result, pairString) {
        var pos = pairString.indexOf('=');
        if (pos <= 0) {
          return _objectSpread(_objectSpread({}, result), {}, {
            pairString: true
          });
        }
        var key = pairString.substr(0, pos);
        var value = pairString.substr(pos + 1);
        return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, value));
      }, {});
    };
  }
}), lifecycle({
  componentWillMount: function componentWillMount() {
    // TODO: Need to refactor this to be smarter when we start supporting more tabs.
    // Probably using something like https://reactrouter.com/en/main/hooks/use-match#usematch
    var pathname = window.location.pathname;
    var pathnameTab = pathname.includes('/requirements/') ? 'Applicant Requirements' : pathname.includes('/notes') ? 'Notes' : pathname.includes('/admin-comments') ? 'Admin Comments' : pathname.includes('/admin-requirements') ? 'Admin Requirements' : undefined;
    var searchParameter = this.props.searchParameters();
    var parameterTab = searchParameter.tab ? searchParameter.tab.replace(/-/, ' ') : null;
    var correctTab = pathnameTab || parameterTab || this.props.tab || null;
    this.props.init(this.props.applicationId, this.props.permissions, correctTab);
  }
}));
export default enhancer(Application);